import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { LoaderService } from '@core/services/loader.service/loader.service';

/**
 * Fullscreen UI-blocking loader driven by LoaderService.
 * Rendered once in the root component.
 */
@Component({
  selector: 'app-loader-overlay',
  imports: [MatProgressSpinnerModule, TranslatePipe],
  template: `
    @if (loader.visible()) {
      <div class="loader-backdrop" role="alert" aria-busy="true">
        <mat-spinner [diameter]="56" />
        <span class="app-visually-hidden">{{ 'loader.loading' | translate }}</span>
      </div>
    }
  `,
  styleUrl: './loader-overlay.scss',
})
export class LoaderOverlay {
  protected readonly loader = inject(LoaderService);
}
